// extracted by mini-css-extract-plugin
module.exports = {"container":"EnableVariation_container__3-44_","title":"EnableVariation_title__1bgpe","tooltip":"EnableVariation_tooltip__10oNt"};